
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
} from "reactstrap"

import React, { useEffect } from "react"
import FIELDS, { MEDIA_FIELDS } from "./CONSTANT"
import { FieldInput } from "../../../components/FieldInput"
import { usePagination } from "../../../hooks/usePagination";
import { getEmployees } from "../../../api/employees";




export default function PayslipeForm({validation}){

    const { response, setPayload, setMetaKey, meta } = usePagination(
        getEmployees
      );

    function handleChooseAllEmployees(){
        validation.setFieldValue('employees', (response.data.data || response.data)['employees']
        .map((c) => {
            return c.id 
        }))
    }

    return(
        <Row>
            <Col md={12}>
                <Card>
                    <CardBody>

                        <Row>
                            {MEDIA_FIELDS.map(f => (
                                <FieldInput key={f.key} f={f} validation={validation} />
                            ))}
                        
                        </Row>
                        <div className="d-flex" style={{justifyContent: "flex-end"}}>
                        <Button color="dark" onClick={handleChooseAllEmployees}>Select All Employees</Button>

                        </div>
                    </CardBody>
                </Card>
            </Col>
          
        </Row>
    )
}